import { Component, Injector, OnInit } from '@angular/core';
import { RelatedTabBaseComponent } from '../related-tab-base.component';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { filter, map, takeUntil, tap, withLatestFrom } from 'rxjs';
import { DocViewerContextDoc } from '@models/ui/doc-viewer-context-doc.model';
import { EmailTypeToDisplayTypeMap } from '@models/mappers/maps/email-type-to-display-type.map';

@Component({
    selector: 'lex-split-sub-panel',
    templateUrl: './split-sub-panel.component.html',
    styleUrls: ['./split-sub-panel.component.scss'],
    standalone: false
})
export class SplitSubPanelComponent extends RelatedTabBaseComponent implements OnInit {
	constructor(
		private injector: Injector
	) {
		super(injector)


	}
	private _transformer = (node: TreeNode, level: number) => {
		return {
			expandable: !!node.children && node.children.length > 0,
			docTitle: node.docTitle,
			docId: node.docId,
			level: level,
			displayType: node.displayType
		};
	};

	public treeControl = new FlatTreeControl<FlatNode>(
		node => node.level,
		node => node.expandable
	);

	private treeFlattener = new MatTreeFlattener(
		this._transformer,
		node => node.level,
		node => node.expandable,
		node => node.children
	);

	public dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

	public hasChild = (_: number, node: FlatNode) => node.expandable;

	public isCurrent(node: FlatNode): boolean {
		return this.currentDocumentSnapshot && node.docId == this.currentDocumentSnapshot.docId;
	}

	public ngOnInit(): void {
		this.docViewerStore.currentDocument$.pipe(
			tap(() => this.dataSource.data = []),
			withLatestFrom(this.docViewerStore.simpleState$),
			map(([, state]) => state.splitDoc),
			filter((splitDoc => !!splitDoc)),
			tap((splitDoc) => {
				const node: TreeNode = {
					docTitle: splitDoc.parent.title,
					docId: splitDoc.parent.id,
					displayType: EmailTypeToDisplayTypeMap.get(splitDoc.parent.emailType.value),
					children: splitDoc.children.map(x => {
						return {
							docTitle: x.title,
							docId: x.id,
							displayType: EmailTypeToDisplayTypeMap.get(x.emailType.value),
							children: []
						};
					})
				};

				this.dataSource.data = [node];
				this.treeControl.expandAll();
			}),
			takeUntil(this.destroy$)
		).subscribe();
	}

	public toDocContext(node: FlatNode): DocViewerContextDoc {
		const item = new DocViewerContextDoc();
		item.docId = node.docId
		item.docTitle = node.docTitle;
		item.displayType = node.displayType;
		return item;
	}
}

export interface TreeNode {
	docTitle: string;
	docId: string;
	displayType: 'native' | 'email' | 'attachment';
	children?: TreeNode[];
}

interface FlatNode {
	expandable: boolean;
	docTitle: string;
	docId: string;
	displayType: 'native' | 'email' | 'attachment';
	level: number;
}
